import React from 'react';
import axios from 'axios';
import { useSearchParams, useParams, Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

import MainInfo from '../Components/SectionsForAccountPage/MainInfo';
import AMRegions from '../Components/SectionsForAccountPage/AMRegions';
import Education from '../Components/SectionsForAccountPage/Education';
import Qualification from '../Components/SectionsForAccountPage/Qualification';
import EmploymentHistory from '../Components/SectionsForAccountPage/EmploymentHistory';
import Certificates from '../Components/SectionsForAccountPage/Certificates';
import Insurance from '../Components/SectionsForAccountPage/Insurance';
import MembershipsSRO from '../Components/SectionsForAccountPage/MembershipsSRO';
import Verifications from '../Components/SectionsForAccountPage/Verifications';
import AdministrativeResponsibility from '../Components/SectionsForAccountPage/AdministrativeResponsibility';
import DisciplinaryCommittee from '../Components/SectionsForAccountPage/DisciplinaryCommittee';

import AMMembershipFees from '../Components/TablesForMembershipFeesPage/AMMembershipFees';
import PendingApplications from '../Components/TablesForApplicationsPage/SectionsForAMApplications/PendingApplications';
import TrashPendingApplications from '../Components/TablesForApplicationsPage/SectionsForAMApplications/TrashPendingApplications';
import ActiveAMApplicationsCases from '../Components/TablesForApplicationsPage/SectionsForAMApplications/ActiveAMApplicationsCases';
import UsersCases from '../Components/SectionsForAccountPage/UserCases';

import HeadlinePanel from '../Components/HeadlinePanel';

import styles from '../styles/Account.module.css';
import subpageSelection from '../styles/SubpageSelection.module.css';

export default function Account() {
    const [searchParams, setSearchParams] = useSearchParams();
    const section = searchParams.get('section') || 'main-info';

    const { id: routeId } = useParams();
    const [id, setId] = React.useState(null);
    const [isMyAccount, setIsMyAccount] = React.useState(null);
    const [role, setRole] = React.useState(null);
    const [redirect, setRedirect] = React.useState(null);

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            setRedirect('/auth/login');
            return;
        }

        try {
            const decodedToken = jwtDecode(token);
            const actualId = routeId || decodedToken.id;

            setId(actualId);
            setIsMyAccount(!routeId);

            // Если это чужой аккаунт и токен не админа — редирект на 404
            if (routeId && decodedToken.role !== 'АппаратСРО') {
                setRedirect('/404');
                return;
            }

            // Получаем роль пользователя по actualId
            axios.get(`/api/get-user-role?id=${actualId}`)
                .then(res => setRole(res.data.role))
                .catch(err => console.error('Ошибка получения роли:', err));

        } catch (error) {
            console.error('Ошибка при декодировании токена: ', error);
            setRedirect('/home');
        }
    }, [routeId]);

    if (redirect) {
        return <Navigate to={redirect} replace />;
    }

    if (id === null || isMyAccount === null) {
        return <div>Загрузка...</div>;
    }


    return (
        <div className='mainContainer'>
            <HeadlinePanel label='Анкета' type='Назад' />
            <div className='containerInner'>
                <div className={subpageSelection.panel}>
                    <a onClick={() => setSearchParams({ section: 'main-info' })} className={`${subpageSelection.buttonToSubPages} ${section === 'main-info' ? subpageSelection.active : ''}`}>Основное</a>
                    {(!isMyAccount && role=='Арбитражный управляющий') && 
                    <>
                        <a onClick={() => setSearchParams({ section: 'membership-fees' })} className={`${subpageSelection.buttonToSubPages} ${section === 'membership-fees' ? subpageSelection.active : ''}`}>Членские взносы</a>
                        <a onClick={() => setSearchParams({ section: 'pending-applications' })} className={`${subpageSelection.buttonToSubPages} ${(section === 'pending-applications' || section === 'trash-pending-applications') ? subpageSelection.active : ''}`}>Заявки управляющего, по которым ожидается решение СРО</a>
                        <a onClick={() => setSearchParams({ section: 'applications' })} className={`${subpageSelection.buttonToSubPages} ${section === 'applications' ? subpageSelection.active : ''}`}>Активные заявки управляющего</a>
                        <a onClick={() => setSearchParams({ section: 'users-cases' })} className={`${subpageSelection.buttonToSubPages} ${section === 'users-cases' ? subpageSelection.active : ''}`}>Картотека управляющего</a>
                    </>
                    }
                    {role==='Арбитражный управляющий' &&
                    <>
                        <a onClick={() => setSearchParams({ section: 'am-regions' })} className={`${subpageSelection.buttonToSubPages} ${section === 'am-regions' ? subpageSelection.active : ''}`}>Регионы ведения дел</a>
                        <a onClick={() => setSearchParams({ section: 'education' })} className={`${subpageSelection.buttonToSubPages} ${section === 'education' ? subpageSelection.active : ''}`}>Образование</a>
                        <a onClick={() => setSearchParams({ section: 'qualification' })} className={`${subpageSelection.buttonToSubPages} ${section === 'qualification' ? subpageSelection.active : ''}`}>Квалификация</a>
                        <a onClick={() => setSearchParams({ section: 'employment-history' })} className={`${subpageSelection.buttonToSubPages} ${section === 'employment-history' ? subpageSelection.active : ''}`}>Стаж</a>
                        <a onClick={() => setSearchParams({ section: 'certificates' })} className={`${subpageSelection.buttonToSubPages} ${section === 'certificates' ? subpageSelection.active : ''}`}>Справки</a>
                        <a onClick={() => setSearchParams({ section: 'insurance' })} className={`${subpageSelection.buttonToSubPages} ${section === 'insurance' ? subpageSelection.active : ''}`}>Страхование</a>
                        <a onClick={() => setSearchParams({ section: 'memberships-sro' })} className={`${subpageSelection.buttonToSubPages} ${section === 'memberships-sro' ? subpageSelection.active : ''}`}>Членство в СРО</a>
                        <a onClick={() => setSearchParams({ section: 'verifications' })} className={`${subpageSelection.buttonToSubPages} ${section === 'verifications' ? subpageSelection.active : ''}`}>Проверки</a>
                        <a onClick={() => setSearchParams({ section: 'administrative-responsibility' })} className={`${subpageSelection.buttonToSubPages} ${section === 'administrative-responsibility' ? subpageSelection.active : ''}`}>Административная ответственность</a>
                        <a onClick={() => setSearchParams({ section: 'disciplinary-committee' })} className={`${subpageSelection.buttonToSubPages} ${section === 'disciplinary-committee' ? subpageSelection.active : ''}`}>Дисциплинарный комитет</a>
                    </>}
                </div>
                <div className='pageWrapper'>
                    {section == 'main-info' ? <MainInfo userId={id} />
                    : section == 'am-regions' ? <AMRegions userId={id} />
                    : section == 'education' ? <Education userId={id} />
                    : section == 'qualification'? <Qualification userId={id} />
                    : section == 'employment-history'? <EmploymentHistory userId={id} />
                    : section == 'certificates'? <Certificates userId={id} />
                    : section == 'insurance'? <Insurance userId={id} />
                    : section == 'memberships-sro'? <MembershipsSRO userId={id} />
                    : section == 'verifications'? <Verifications userId={id} />
                    : section == 'administrative-responsibility'? <AdministrativeResponsibility userId={id} />
                    : section == 'disciplinary-committee'? <DisciplinaryCommittee userId={id} />
                    : section == 'membership-fees' ? <AMMembershipFees userId={id} isFromAccount={true} />
                    : section == 'pending-applications' ? <PendingApplications userId={id} isFromAccount={true} />
                    : section == 'trash-pending-applications' ? <TrashPendingApplications userId={id} isFromAccount={true} />
                    : section == 'applications' ? <ActiveAMApplicationsCases userId={id} isFromAccount={true} />
                    : section == 'users-cases' ? <UsersCases userId={id} />
                    : <a className='description'>Выберите вкладку</a>}
                </div>
            </div>
        </div>
    )
}
